import Container from "../di/container";
import {SoundType} from "../service/soundService";

export const StopSound = (soundEffect: SoundType) => {
    Container.getSoundService().stop(soundEffect);
}